export default {"src":"/_next/static/media/seb_black.4a1db2a0.svg","height":489,"width":209,"blurWidth":0,"blurHeight":0};